import { Badge, Box, Group, Stack, Text, Tooltip } from '@mantine/core';

const ConnectionCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    const connectionStatus = rowData.status || 'Disconnected';
    const agentType = rowData.type;

    const typeBadgeLookup = {
        Epdg: 'teal.6',
        Modem: 'blue',
        default: 'gray',
    };
    const typeColor = typeBadgeLookup[agentType] || typeBadgeLookup['default'];

    const connectionStatusBadgeLookup = {
        Connected: 'teal.6',
        Disconnected: 'red.6',
        default: 'gray',
    };
    const connectionColor =
        connectionStatusBadgeLookup[connectionStatus] ||
        connectionStatusBadgeLookup['default'];

    return (
        <Stack
            gap={2}
            justify='center'
            align={'center'}>
            <Tooltip label={''}>
                <Badge
                    color={connectionColor}
                    size={'xs'}>
                    {connectionStatus}
                </Badge>
            </Tooltip>
            <Badge
                color={typeColor}
                size={'xs'}>
                {rowData.type}
            </Badge>
        </Stack>
    );
};

const ConnectionColumn = () => ({
    accessorKey: 'connectionStatus',
    header: 'Connected / Type',
    size: 2,
    minSize: 60,
    Cell: ({ cell }) => <ConnectionCell cell={cell} />,
});
export default ConnectionColumn;
